import clsx from 'clsx';
import { useIsTruncated } from '../../hooks';
import { Tooltip } from '../tooltip';

const DEFAULT_TOOLTIP_PROPS = {
  bubbleAlign: 'center',
  wrap: 'normal',
  bubbleWidthPx: 320,
  followCursor: true,
  showArrow: false,
};

export function TruncatedText({
  as: Component = 'span',
  className,
  truncatedClassName,
  triggerClassName,
  tooltipContent,
  tooltipProps,
  children,
  ...rest
}) {
  const { ref, isTruncated } = useIsTruncated(children);
  const content = isTruncated ? (tooltipContent ?? children) : null;

  return (
    <Tooltip
      {...DEFAULT_TOOLTIP_PROPS}
      {...tooltipProps}
      content={content}
      triggerClassName={clsx(triggerClassName)}
    >
      <Component ref={ref} className={clsx(className, isTruncated && truncatedClassName)} {...rest}>
        {children}
      </Component>
    </Tooltip>
  );
}
